<template>
  <div class="contents">
    <div class="create_wrap">
      <div class="create_head">
        <div class="tit">부고장 생성</div>
      </div>
      <div class="create_body obit">
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>임종 일시</span>
                </th>
                <td>
                  <div class="wrapper date">
                    <div class="input_wrap">
                      <SelectList
                        v-model="deathbedYear"
                        :options="yearOptions"
                        unit="년"
                        selectClass="select_box type2"
                      />
                    </div>
                    <div class="input_wrap">
                      <SelectList
                        v-model="deathbedMonth"
                        :options="monthOptions"
                        unit="월"
                        selectClass="select_box"
                      />
                    </div>
                    <div class="input_wrap">
                      <SelectList
                        v-model="deathbedDay"
                        :options="getDayOptions(deathbedYear, deathbedMonth)"
                        unit="일"
                        selectClass="select_box"
                      />
                    </div>
                    <div class="input_wrap">
                      <span class="time"></span>
                      <input
                        type="text"
                        placeholder="14:30"
                        v-model="funeralInvitation.deathbedTime"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>발인 일시</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <SelectList
                        v-model="funeralYear"
                        :options="yearOptions"
                        unit="년"
                        selectClass="select_box type2"
                      />
                    </div>
                    <div class="input_wrap">
                      <SelectList
                        v-model="funeralMonth"
                        :options="monthOptions"
                        unit="월"
                        selectClass="select_box"
                      />
                    </div>
                    <div class="input_wrap">
                      <SelectList
                        v-model="funeralDay"
                        :options="getDayOptions(funeralYear, funeralMonth)"
                        unit="일"
                        selectClass="select_box"
                      />
                    </div>
                    <div class="input_wrap">
                      <span class="time"></span>
                      <input
                        type="text"
                        placeholder="14:30"
                        v-model="funeralInvitation.funeralTime"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr colspan="2">
                <th rowspan="2">
                  <span>장례식장명</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap select_box type4">
                      <select class="btn_select ellipsis" v-model="funeralInvitation.partnerSeq" @change="onPartnerChange">
                        <option :value="null">장례식장 선택</option>
                        <option v-for="partner in this.partnerListWithDetails" :key="partner.partnerSeq" :value="partner.partnerSeq">
                          {{ partner.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap select_box type4">
                      <span class="txt">빈소</span>
                      <select class="btn_select ellipsis" v-model="selectedPartnerDetailSeq" @change="onPartnerDetailChange" :disabled="!funeralInvitation.partnerSeq">
                        <option :value="null">직접입력</option>
                        <option v-for="detail in partnerDetails" :key="detail.seq" :value="detail.seq">
                          {{ detail.name }}
                        </option>
                      </select>
                    </div>
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="층 / 실"
                        v-model="funeralInvitation.funeralLocationDtl"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--
        <div class="create_tit">메인 디자인</div>
        <div class="design_wrap">
          <ul class="list_main">
            <li
              v-for="design in designList"
              :class="funeralInvitation.mainDesign === design.idx ? 'select' : ''"
            >
              <div class="img_wrap">
                <img :src="design.img" alt="" />
              </div>
              <a class="btn_choice" @click="selectDesign(design.idx)">선택</a>
            </li>
          </ul>
        </div>
        <div class="create_tit">부고 정보</div>
        -->
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>고인명</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="홍길동"
                        v-model="funeralInvitation.deceasedName"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>연세</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input type="text" placeholder="99" v-model="funeralInvitation.age" />
                    </div>
                  </div>
                </td>
              </tr>
              <!--
              <tr>
                <th>
                  <span>상주</span>
                </th>
                <td>
                  <div class="wrapper">
                    <textarea name="" id="" v-model="funeralInvitation.mourners"></textarea>
                  </div>
                </td>
              </tr>
              -->
            </tbody>
          </table>
        </div>
        <!--
        <div class="create_tit">안내하는 글</div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>메인 메시지</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        v-model="selectedMainMessage"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in mainMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <div class="input_wrap type0">
                      <input
                        type="text"
                        placeholder="부 고  /  訃告  /  謹弔"
                        v-model="funeralInvitation.mainMessage"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>인사말</span>
                </th>
                <td>
                  <div class="wrapper type0">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        v-model="selectedGreetingsMessage"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in greetingsMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <textarea class="type0"
                      placeholder="인사말을 선택하거나 직접 입력하세요."
                      v-model="funeralInvitation.greetingsMessage"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">상주 연락처</div>
        -->
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>상주 대표자</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="아이디"
                        v-model="funeralInvitation.mainMournerId"
                      />
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="funeralInvitation.mainMournerName"
                      />
                      <input
                        type="text"
                        placeholder="연락처 (- 없이 입력)"
                        v-model="funeralInvitation.mainMournerPhone"
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="funeralInvitation.mainMournerPhone = (funeralInvitation.mainMournerPhone || '').replace(/\D/g,'')"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--
        <div class="create_tit">사진 갤러리</div>
        <div class="design_wrap">
          <ul class="list_gallery">
            <li :class="funeralInvitation.galleryType === 1 ? 'select' : ''" @click="selectGallery(1)" style="display:none;">
              <div class="img_wrap">
                <div class="quarter">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <a>더보기</a>
              </div>
              <a class="btn_choice">선택</a>
            </li>
            <li :class="funeralInvitation.galleryType === 2 ? 'select' : ''" @click="selectGallery(2)">
              <div class="img_wrap">
                <div class="preview"></div>
                <ul class="thumb">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <a class="btn_choice">선택</a>
            </li>
            <li>
              <div class="img_wrap">
                <button class="btn_photoAdd" @click="triggerFileInput"></button>
                <input
                  type="file"
                  ref="fileInput"
                  accept="image/*"
                  multiple
                  @change="handleFileChange"
                  style="display: none"
                />
              </div>
              <p>
                갤러리 사진 업로드
                <span>( {{ attachList.length }} / 12 )</span>
              </p>
            </li>
            <li v-for="(attach, index) in attachList" :key="index">
              <div class="img_wrap">
                <img :src="attach.preview" alt="미리보기 이미지" />
              </div>
              <a class="btn_delete" @click="removeAttach(index)"></a>
            </li>
          </ul>
        </div>
        <div class="create_tit">안내 사항</div>
        <p>안내 사항을 기재하실 수 있습니다.</p>
        <div class="example">
          <span>· 예) 장지로 출발하는 버스는 당일 11시에 출발합니다. </span>
          <span>· 예) 위로예배(오륜교회) 8/2(토) 16:00 </span>
          <span>· 예) 위로예배(광야교회) 8/2(토) 17:00 </span>
          <span>· 예) 입관예배(오륜교회) 8/3(일) 18:00 </span>
        </div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>안내사항</span>
                </th>
                <td>
                  <div class="wrapper type0">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        @change="appendNotice($event)"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in noticeMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <textarea class="type0"
                      placeholder="안내사항을 선택하거나 직접 입력하세요."
                      v-model="funeralInvitation.noticeMessage"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">장지 정보</div>
        <p>장지 정보, 전세 버스 등의 안내 사항을 기재하실 수 있습니다.</p>
        <span
          >· 예) 전세 버스 : 당일 오전 11시에 ㅇㅇ역 1번 출구 앞에서 출발</span
        >
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>입관</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input
                        type="text"
                        placeholder="입관"
                        v-model="funeralInvitation.funeralInfoTitle"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>장지</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input
                        type="text"
                        placeholder="장지"
                        v-model="funeralInvitation.funeralInfoDtl"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">위로의 마음 전하기 (송금받기)</div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>메시지</span>
                </th>
                <td>
                  <div class="wrapper type0">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        v-model="selectedThankyouMessage"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in thankyouMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <div class="input_wrap type0">
                      <input
                        type="text"
                        v-model="funeralInvitation.thankyouMessage"
                        placeholder="위로의 마음을 담아 조의금을 전달해 보세요."
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>상주</span>
                </th>
                <td>
                  <div class="wrapper" v-for="(mourner, index) in funeralInvitation.mournerList">
                    <div class="input_wrap">
                      <input type="text" placeholder="상주 이름" v-model="mourner.name" />
                      <input type="text" placeholder="은행명" v-model="mourner.bankName" />
                      <input type="text" placeholder="계좌 번호" v-model="mourner.bankInfo" 
                        inputmode="numeric" pattern="\d*"  
                        @input="mourner.bankInfo = (mourner.bankInfo || '').replace(/\D/g,'')" />
                      <input type="text" placeholder="전화 번호" v-model="mourner.phoneNumber" 
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="mourner.phoneNumber = (mourner.phoneNumber || '').replace(/\D/g,'')" />
                    </div>
                    <div class="btn_box">
                      <a class="btn_del" @click="deleteMourner(index)"></a>
                      <a class="btn_add" @click="addMourner" v-if="index === 0"></a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">디지털 기부 화환 설정</div>
        -->
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr style="display:none;">
                <th>
                  <span>기부 화환 적용</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="form_wrap">
                      <label for="apply" class="radio_wrap">
                        <input
                          type="radio"
                          id="apply"
                          name="apply"
                          :value="true"
                          v-model="funeralInvitation.useCampaign"
                        />
                        <span>적용</span>
                      </label>
                      <label for="applyNot" class="radio_wrap">
                        <input
                          type="radio"
                          id="applyNot"
                          name="apply"
                          :value="false"
                          v-model="funeralInvitation.useCampaign"
                        />
                        <span>미적용</span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <!--
              <tr v-if="funeralInvitation.useCampaign">
                <th>
                  <span>분류</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <SelectList
                        v-model="selectedCategory"
                        :options="optionCategoryList"
                        unit=""
                        selectClass="select_box type3"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              -->
              <tr v-if="funeralInvitation.useCampaign">
                <th>
                  <span>캠페인 선택</span>
                </th>
                <td>
                  <ul class="list_campaign">
                    <li
                      v-for="campaign in filteredCampaigns"
                      :class="
                        funeralInvitation.campaignSeq === campaign.campaignSeq
                          ? 'select'
                          : ''
                      "
                    >
                      <div class="img_wrap">
                        <img
                          :src="
                            campaign.thumbnailPath
                              ? $getImgUrl(campaign.thumbnailPath)
                              : require('../../assets/images/common/campaign_img_01.png')
                          "
                          style="max-width: 100%"
                        />
                      </div>
                      <div class="txt_wrap">{{ campaign.campaignName }}</div>
                      <a class="btn_choice" @click="selectCampaign(campaign)"
                        >선택</a
                      >
                    </li>
                  </ul>
                </td>
              </tr>
              <!--
              <tr v-if="funeralInvitation.useCampaign">
                <th>
                  <span>키오스크 화면</span>
                </th>
                <td>
                  <div class="design_wrap">
                    <ul class="list_kiosk">
                      <li
                        v-for="style in kioskStyles"
                        :key="style.id"
                        :class="{ select: String(funeralInvitation.kioskStyle) === String(style.id) }"
                        @click="selectKioskStyle(style.id)"
                      >
                        <div class="img_wrap">
                          <img
                            :src="require(`@/assets/images/common/${style.imgSrc}`)"
                            :alt="style.altText"
                          />
                        </div>
                        <a class="btn_choice">선택</a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              -->
            </tbody>
          </table>
        </div>
        <!--
        <div class="create_tit" v-if="!isAuthenticated">비회원 계정 생성</div>
        <span v-if="!isAuthenticated">· 비회원으로 생성 시 이름, 전화번호, 주문번호가 비회원 로그인에 사용됩니다.</span>
        <div class="tbl_wrap" v-if="!isAuthenticated">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>이름</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input type="text" placeholder="이름" v-model="funeralInvitation.nonMemberName"/>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>전화번호</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input type="text" placeholder="전화번호" v-model="funeralInvitation.nonMemberPhone"
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="funeralInvitation.nonMemberPhone = (funeralInvitation.nonMemberPhone || '').replace(/\D/g,'')" />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">기타 설정 (오시는 길)</div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>카카오맵 사용</span>
                </th>
                <td>
                  <div class="wrapper">
                    <span class="search_box">
                      <input type="text" placeholder="장례식장 검색" name="keyword" @keyup.enter="searchPlace" v-model="name" />
                      <button type="button" @click="searchPlace" >검색버튼</button>
                    </span>
                    <p>· 생성 이후 마이페이지에서 확인 가능합니다.</p>
                  </div>
                  <ul>
                    <li v-for="place in places" :key="place.id" @click="selectPlace(place)">
                      {{ place.place_name }}
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th></th>
                <td>
                  <div id="map" style="width:95%;height:400px;"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        -->
      </div>
      
      <div class="create_button">
        <!--
        <button type="button" class="btn_preview">미리보기</button>
        -->
        <button type="button" class="btn_save" @click="edit(invitationSeq)">저장하기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SelectList from "../../components/common/SelectList.vue";

const campaignModule = "campaignModule";
const categoryModule = "categoryModule";
const funeralModule = "funeralModule";
const accountModule = 'accountModule';
const partnerModule = 'partnerModule';
const apiGuideModule = "apiGuideModule";

export default {
  props: {
      orderNum: {
          type: Number,
          required: true,
      }
  },
  components: {
    SelectList,
  },
  data() {
    return {
      deathbedYear: new Date().getFullYear().toString(),
      deathbedMonth: (new Date().getMonth() + 1).toString(),
      deathbedDay: new Date().getDate().toString(),
      funeralYear: new Date().getFullYear().toString(),
      funeralMonth: (new Date().getMonth() + 1).toString(),
      funeralDay: new Date().getDate().toString(),
      designList: [
        { idx: 1, img: require("../../assets/images/common/obit_img_01.png") },
        { idx: 2, img: require("../../assets/images/common/obit_img_02.png") },
        { idx: 3, img: require("../../assets/images/common/obit_img_03.png") },
        { idx: 4, img: require("../../assets/images/common/obit_img_04.png") },
      ],
      selectedCategory: "선택",
      currentPage: 1,
      currentCategorySeq: "",

      yearOptions: this.getYearOptions(),
      monthOptions: this.getMonthOptions(),
      dayOptions: [],

      places: [],
      name: '',
      map: null,

      funeralInvitation: {
        deathbedDate: new Date().toISOString().split("T")[0],
        deathbedTime: "",
        funeralDate: new Date().toISOString().split("T")[0],
        funeralTime: "",
        funeralLocationName: "",
        funeralLocationDtl: "",

        mainDesign: 1,

        mainMessage: "",
        greetingsMessage: "",

        deceasedName: "",
        age: "",
        mourners: "",

        mainMournerId: "",
        mainMournerName: "",
        mainMournerPhone: "",

        galleryType: 2,

        funeralInfoTitle: "",
        funeralInfoDtl: "",

        thankyouMessage: "",

        useCampaign: true,
        campaignSeq: null,

        funeralLatitude: 37.5665,
        funeralLongitude: 126.9780,
        mapAddress: "",

        nonMemberName: "",
        nonMemberPhone: "",

        mournerList: [
          { name: "", bankName: "", bankInfo: "" },
        ],

        kioskStyle: 1,

        noticeMessage: "",

        partnerSeq: null
      },

      attachList: [],

      mainMessageOptions: [
        '사랑하는 故○○○님께서 하나님의 부르심을 받아 평안히 잠드셨습니다.',
        '사랑하는 故○○○님의 영면을 삼가 알려드립니다.',
        '故○○○님께서 삶의 여정을 마치시고 하나님의 품으로 돌아가셨습니다.'
      ],
      greetingsMessageOptions: [
        '하나님의 크신 은혜 가운데 살아오시던 저희 아버지(어머니, 가족) ○○○님께서 소천하셨기에 삼가 알려드립니다.\n오셔서 마지막 길을 축복해 주시면 감사하겠습니다.',
        '삶을 사랑하시고 가족을 아끼시던 故○○○님께서 영면하셨기에 삼가 알려드립니다.\n함께 하셔서 고인의 평안을 기도해주시고 유족에게 따뜻한 위로를 전해주시면 감사하겠습니다.',
        '평생을 곧게 살아오신 저희 부친(모친) ○○○님께서 향년 ○○세로 영면에 드셨습니다.\n고인의 마지막 길에 함께해주시어 마음을 모아주시길 부탁드립니다.'
      ],
      thankyouMessageOptions: [
        '마음을 전하실 곳'
      ],
      noticeMessageOptions: [
        '실물화환은 정중히 사양합니다. 디지털 기부화환으로 축하의 마음을 전해주세요.'
      ],

      kioskStyles: [
        { id: 1, imgSrc: "kiosk_style_funeral_01.png", altText: "키오스크 스타일 1" },
        { id: 2, imgSrc: "kiosk_style_funeral_02.png", altText: "키오스크 스타일 2" },
        { id: 3, imgSrc: "kiosk_style_funeral_03.png", altText: "키오스크 스타일 3" },
        { id: 4, imgSrc: "kiosk_style_funeral_04.png", altText: "키오스크 스타일 4" }
      ],

      selectedPartnerDetailSeq: null
    };
  },

  methods: {
    ...mapActions(campaignModule, ["requestCampaignList", "requestFilteredCampaignList"]),
    ...mapActions(categoryModule, ["requestCategoryList"]),
    ...mapActions(funeralModule, [ 'requestCreateFuneralInvitation' ]),
    ...mapActions(accountModule, ['requestCheckLogin', ]),
    ...mapActions(partnerModule, ['requestPartnersWithDetails']),
    ...mapActions(apiGuideModule, ['requestInvitationApiDetail', 'requestFuneralInvitationEditApi', 'requestCampaignApiDetail']),

    getYearOptions() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 10 }, (_, i) => String(currentYear + i));
    },

    getMonthOptions() {
      return Array.from({ length: 12 }, (_, i) => String(i + 1));
    },

    getDayOptions(year, month) {
      const daysInMonth = new Date(year, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => String(i + 1));
    },

    selectDesign(idx) {
      this.funeralInvitation.mainDesign = idx;
    },

    selectGallery(type) {
      this.funeralInvitation.galleryType = type;
    },

    addMourner() {
      const mourner = { name: "", bankName: "", bankInfo: "" };
      this.funeralInvitation.mournerList.push(mourner);
    },

    deleteMourner(idx) {
      if (this.funeralInvitation.mournerList.length !== 1) {
        this.funeralInvitation.mournerList.splice(idx, 1);
      } else {
        this.funeralInvitation.mournerList = [{ name: "", bankName: "", bankInfo: "" },];
      }
    },

    selectCampaign(campaign) {
      this.funeralInvitation.campaignSeq = campaign.campaignSeq;
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const files = event.target.files;
      if (!files.length) return;
      if (files.length > 12) {
        this.$openModal('alertModal', {
          message: "사진은 최대 12장만 업로드 가능합니다."
        })
        return;
      }

      const newFiles = Array.from(files).map((file) => ({
        name: file.name,
        file: file,
        preview: URL.createObjectURL(file),
      }));
      this.attachList = [...this.attachList, ...newFiles];
    },

    removeAttach (idx) {
      this.attachList.splice(idx, 1);
    },

    initMap (x, y) {
      var container = document.getElementById('map');
      var options = {
        center: new kakao.maps.LatLng(x, y),
        level: 4,
        draggable: false
      };
      this.map = new kakao.maps.Map(container, options);
    },

    searchPlace() {
      const ps = new kakao.maps.services.Places();
      ps.keywordSearch(this.name, (data, status) => {
        if (status === kakao.maps.services.Status.OK) {
          this.places = data;
        }
      });
    },

    async selectPlace(place) {
      this.name = place.place_name;
      this.funeralInvitation.funeralLatitude = place.y;
      this.funeralInvitation.funeralLongitude = place.x;
      this.funeralInvitation.mapAddress = place.address_name

      const newPosition = new kakao.maps.LatLng(place.y, place.x);

      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      if (this.infoWindow) {
        this.infoWindow.close();
        this.infoWindow = null;
      }

      this.marker = new kakao.maps.Marker({
        position: newPosition,
        map: this.map,
      });

      if (this.map) {
        this.map.setCenter(new kakao.maps.LatLng(place.y, place.x));
      }

      if (this.name) {
        this.infoWindow = new kakao.maps.InfoWindow({
          content: `<div style="padding:5px;font-size:14px;">${place.place_name}</div>`,
        });
        this.infoWindow.open(this.map, this.marker);
      }
    },

    async edit() {
      const { funeralInvitation } = this;

      // undefined > null 처리
      const cleanObject = (obj) => {
        return JSON.parse(
          JSON.stringify(obj, (key, value) => (value === undefined ? null : value))
        );
      };

      funeralInvitation.greetingsMessage = funeralInvitation.greetingsMessage.replace(/\n/g, '<br>')
      funeralInvitation.mourners = funeralInvitation.mourners.replace(/\n/g, '<br>')

      funeralInvitation.deathbedDate = `${this.deathbedYear}-${String(this.deathbedMonth).padStart(2,"0")}-${String(this.deathbedDay).padStart(2,"0")}`;
      funeralInvitation.funeralDate = `${this.funeralYear}-${String(this.funeralMonth).padStart(2,"0")}-${String(this.funeralDay).padStart(2,"0")}`;
      funeralInvitation.funeralInvitationSeq = this.funeralInvitationSeq
      funeralInvitation.campaignSeq = this.funeralInvitation.campaignSeq
      funeralInvitation.orderNum = this.orderNum

      // undefined > null 처리
      const cleanedData = cleanObject(funeralInvitation);

      const formData = new FormData();
      formData.append(
        "funeralInvitation",
        new Blob([JSON.stringify(cleanedData)], { type: "application/json" })
      );

      if (funeralInvitation.partnerSeq === null) {
        this.$openModal('alertModal', {
          message: "장례식장을 선택해주세요."
        });
        return;
      }

      formData.append(
        "deletedAttachSeqs",
        new Blob([JSON.stringify(this.deletedAttachSeqs || [])], { type: "application/json" })
      );
      formData.append('funeralInvitationSeq', this.funeralInvitationSeq);

      const result = await this.requestFuneralInvitationEditApi(formData);
      
      if (result == "Invalid") {
        this.$openModal('alertModal', {
            message: "인증 토큰이 만료되었습니다."
        })
      } else {
        this.makePayment(this.invitation.invitationSeq);
      }
    },

    async makePayment(invitationSeq) {
      // 클릭한 캠페인 객체 찾기
      const campaign = await this.requestCampaignApiDetail(invitationSeq);
      if (!campaign) {
        console.warn('캠페인 정보가 없습니다.');
        return;
      }
      const paymentAmount = campaign.campaignAmount;
      const campaignName = campaign.campaignName;
      const orderNum = this.orderNum;

      // 결제 페이지로 이동
      const routeData = this.$router.resolve({
        name: 'PaymentModalApiPage',
        params: { orderNum }
      });
      window.open(routeData.href, '_blank');

    },

    selectKioskStyle(kioskStyleId) {
      this.funeralInvitation.kioskStyle = kioskStyleId;
    },

    appendNotice(e) {
      const msg = (e.target.value || '').trim()
      if (!msg) return

      const cur = (this.funeralInvitation.noticeMessage || '').toString().trimEnd()
      this.funeralInvitation.noticeMessage = cur ? `${cur}\n${msg}` : msg

      e.target.value = ''
    },

    onPartnerChange() {
      this.selectedPartnerDetailSeq = null;
      this.funeralInvitation.funeralLocationDtl = '';

      if (this.funeralInvitation.partnerSeq) {
        const selectedPartner = this.partnerListWithDetails.find(p => p.partnerSeq === this.funeralInvitation.partnerSeq);
        this.funeralInvitation.funeralLocationName = selectedPartner.name;
        // 선택된 장례식장으로 이동
        this.updateMapByName(this.funeralInvitation.funeralLocationName);
      } else {
        this.funeralInvitation.funeralLocationName = '';
      }
    },

    onPartnerDetailChange() {
      if (this.selectedPartnerDetailSeq) {
        const selectedDetail = this.partnerDetails.find(d => d.seq === this.selectedPartnerDetailSeq);
        this.funeralInvitation.funeralLocationDtl = selectedDetail.name;
      } else {
        this.funeralInvitation.funeralLocationDtl = '';
      }
    },

    updateMapByName(name) {
      const keyword = (name || '').trim();
      if (!keyword) return;

      const ps = new kakao.maps.services.Places();
      ps.keywordSearch(keyword, (data, status) => {
        if (status === kakao.maps.services.Status.OK && data.length > 0) {
          // 첫 번째 검색 결과로 이동
          const place = data[0];
          this.selectPlace(place);
          // 검색 결과 리스트는 초기화(선택 UI 깔끔하게)
          this.places = [];
        }
      });
    },

  },

  computed: {
    ...mapState(campaignModule, ["campaigns", "filteredCampaigns"]),
    ...mapState(categoryModule, ["categories"]),
    ...mapState(accountModule, ["isAuthenticated"]),
    ...mapState(partnerModule, ["partnerListWithDetails"]),
    ...mapState(apiGuideModule, ["invitation", "campaign"]),

    optionCategoryList() {
      return this.categories.map((category) => category.name);
    },

    deathbedDate () {
      return `${this.deathbedYear}-${String(this.deathbedMonth).padStart(2,"0")}-${String(this.deathbedDay).padStart(2, "0")}`;
    },

    funeralDate() {
      return `${this.funeralYear}-${String(this.funeralMonth).padStart(2,"0")}-${String(this.funeralDay).padStart(2, "0")}`;
    },

    selectedMainMessage: {
      get() {
        if (this.mainMessageOptions.includes(this.funeralInvitation.mainMessage)) {
          return this.funeralInvitation.mainMessage;
        }
        return '';
      },
      set(newValue) {
        if ( this.funeralInvitation.deceasedName) {
          newValue = newValue.replace(/○○○님/g, `${ this.funeralInvitation.deceasedName}님`);
        }
        if (this.funeralInvitation.age) {
          newValue = newValue.replace(/○○세/g, `${this.funeralInvitation.age}세`);
        }

        this.funeralInvitation.mainMessage = newValue;
      }
    },
    selectedGreetingsMessage: {
      get() {
        if (this.greetingsMessageOptions.includes(this.funeralInvitation.greetingsMessage)) {
          return this.funeralInvitation.greetingsMessage;
        }
        return '';
      },
      set(newValue) {
        if ( this.funeralInvitation.deceasedName) {
          newValue = newValue.replace(/○○○님/g, `${ this.funeralInvitation.deceasedName}님`);
        }
        if (this.funeralInvitation.age) {
          newValue = newValue.replace(/○○세/g, `${this.funeralInvitation.age}세`);
        }

        this.funeralInvitation.greetingsMessage = newValue;
      }
    },
    selectedThankyouMessage: {
      get() {
        if (this.thankyouMessageOptions.includes(this.funeralInvitation.thankyouMessage)) {
          return this.funeralInvitation.thankyouMessage;
        }
        return '';
      },
      set(newValue) {
        this.funeralInvitation.thankyouMessage = newValue;
      }
    },
    partnerDetails() {
      if (!this.funeralInvitation.partnerSeq) {
        return [];
      }
      const selectedPartner = this.partnerListWithDetails.find(
        partner => partner.partnerSeq === this.funeralInvitation.partnerSeq
      );
      return selectedPartner ? selectedPartner.details : [];
    },
    invitationSeq() {
      return this.invitation.invitationSeq || null;
    },

  },

  async mounted() {
    await this.requestCheckLogin();

    // 기존 부고장 정보 로드 : S
    await this.requestInvitationApiDetail(this.orderNum);
    if(this.invitation.deathBedDate) {
      const deathBedDate = new Date(this.invitation.deathBedDate);
      this.deathbedYear = deathBedDate.getFullYear().toString();
      this.deathbedMonth = (deathBedDate.getMonth() + 1).toString();
      this.deathbedDay = deathBedDate.getDate().toString();
    }
    if(this.invitation.funeralDate) {
      const funeralDate = new Date(this.invitation.funeralDate);
      this.funeralYear = funeralDate.getFullYear().toString();
      this.funeralMonth = (funeralDate.getMonth() + 1).toString();
      this.funeralDay = funeralDate.getDate().toString();
    }
    if(this.invitation.deathbedTime) {
      this.funeralInvitation.deathbedTime = this.invitation.deathbedTime;
    }
    if(this.invitation.funeralTime) {
      this.funeralInvitation.funeralTime = this.invitation.funeralTime;
    }
    if(this.invitation.partnerSeq) {
      this.funeralInvitation.partnerSeq = this.invitation.partnerSeq;
    }
    if(this.invitation.partnerDetailSeq) {
      this.selectedPartnerDetailSeq = this.invitation.partnerDetailSeq;
    }
    if(this.invitation.deceasedName) {
      this.funeralInvitation.deceasedName = this.invitation.deceasedName;
    }
    if(this.invitation.mainMournerId) {
      this.funeralInvitation.mainMournerId = this.invitation.mainMournerId;
    }
    if(this.invitation.mainMournerName) {
      this.funeralInvitation.mainMournerName = this.invitation.mainMournerName;
    }
    if(this.invitation.mainMournerPhone) {
      this.funeralInvitation.mainMournerPhone = this.invitation.mainMournerPhone;
    }
    if(this.invitation.age) {
      this.funeralInvitation.age = this.invitation.age;
    }
    if(this.invitation.funeralLocationDtl) {
      this.funeralInvitation.funeralLocationDtl = this.invitation.funeralLocationDtl;
    }
    // 기존 부고장 정보 로드 : E

    await this.requestPartnersWithDetails('funeral');

    const { currentPage, currentCategorySeq } = this;
    await this.requestCategoryList("캠페인");
    // body에 클래스 추가
    document.body.classList.add('invitation-popup');
    
    const latitude = this.funeralInvitation.funeralLatitude
    const longitude = this.funeralInvitation.funeralLongitude
    this.initMap(latitude, longitude)
    //this.selectPlace({ place_name: '서울특별시청', x: longitude, y: latitude })
    if (this.funeralInvitation.partnerSeq) {
      const p = this.partnerListWithDetails
        .find(pp => pp.partnerSeq === this.funeralInvitation.partnerSeq);
      if (p?.name) this.updateMapByName(p.name);
    } else if (this.funeralInvitation.funeralLocationName) {
      this.updateMapByName(this.funeralInvitation.funeralLocationName);
    }
  },
  unmounted() {
      // 페이지 닫힐 때 클래스 제거
      document.body.classList.remove('invitation-popup');
  },

  watch: {
    selectedCategory: {
      async handler(newCategoryName) {
        const matchedCategory = this.categories.find(
          (category) => category.name === newCategoryName
        );
        this.currentCategorySeq = matchedCategory
          ? matchedCategory.categorySeq
          : "";
        const { currentPage, currentCategorySeq } = this;
        await this.requestCampaignList({ currentPage, currentCategorySeq });
      },
    },
    'funeralInvitation.funeralLocationName'(name) {
      const matchExists = this.partnerListWithDetails.some(
        partner => partner.name === name
      );
      if (!matchExists) {
        this.funeralInvitation.partnerSeq = null;
        this.selectedPartnerDetailSeq = null;
        // this.funeralInvitation.funeralLocationDtl = '';
      }
    },
    'funeralInvitation.funeralLocationDtl'(detailName) {
      const matchExists = this.partnerDetails.some(
        detail => detail.name === detailName
      );
      if (!matchExists) {
        this.selectedPartnerDetailSeq = null;
      }
    },
    'funeralInvitation.partnerSeq'(partnerSeq) {
      this.funeralInvitation.campaignSeq = null;

      this.requestFilteredCampaignList({
        partnerSeq: partnerSeq,
        limit: 7,
        campaignType: 'FUNERAL'
      });
    },
    // 기존 부고장 정보 로드 : S [캠페인 목록이 변경될 때 첫 번째 캠페인 자동 선택]
    filteredCampaigns: {
      handler(newList) {
        if (Array.isArray(newList) && newList.length > 0) {
          // 기존 부고장에 저장된 campaignSeq가 있다면 그걸 우선 적용
          if (this.invitation.campaignSeq) {
            const match = newList.find(
              c => c.campaignSeq === this.invitation.campaignSeq
            );
            if (match) {
              this.funeralInvitation.campaignSeq = match.campaignSeq;
              return;
            }
          }

          // 기존 campaignSeq 없거나 리스트에 해당 캠페인 없을 때, 첫 번째로 기본 선택
          if (!this.funeralInvitation.campaignSeq) {
            const firstCampaign = newList[0];
            this.funeralInvitation.campaignSeq = firstCampaign.campaignSeq;
          }
        }
      },
      immediate: true,
    },
    // 기존 부고장 정보 로드 : E [캠페인 목록이 변경될 때 첫 번째 캠페인 자동 선택]

  },
};
</script>
<style >
    /* 전역 레이아웃 감춤 */
    body.invitation-popup #header,
    body.invitation-popup #footer {
    display: none !important;
    }
</style>